import * as React from "react";
import { AlertCircle } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

interface Props {
  title?: string;
  error?: Error | unknown;
  message?: string;
  className?: string;
}

export const ErrorAlert: React.FC<Props> = ({ title = "Something went wrong", error, message, className }) => {
  const errorMessage = message ?? (error instanceof Error ? error.message : "An unexpected error occurred");

  return (
    <div className={className ?? "flex items-start justify-center p-8 pt-[250px]"}>
      <Alert variant="destructive" className="max-w-md">
        <AlertCircle className="h-4 w-4" />
        <AlertTitle>{title}</AlertTitle>
        <AlertDescription>{errorMessage}</AlertDescription>
      </Alert>
    </div>
  );
};
